import React, { Component, createRef } from "react";
import { getPackages, Package } from "./api/package";
import PackageCard from "../components/PackageCard";
import InquiryModal from "../components/InquiryModal";
import "./PackagesSection.css";

interface State {
  packages: Package[];
  activePackage: Package | null;
}

class PackagesSection extends Component<{}, State> {
  state: State = {
    packages: [],
    activePackage: null,
  };

  scrollRef = createRef<HTMLDivElement>();
  autoScrollInterval: NodeJS.Timeout | null = null;

  async componentDidMount() {
    try {
      const packages = await getPackages(); // API returns only active packages
      this.setState({ packages }, () => this.startAutoScroll());
    } catch (err) {
      console.error("Error loading packages:", err);
    }
  }

  componentDidUpdate(_: {}, prevState: State) {
    if (prevState.activePackage !== this.state.activePackage) {
      document.body.style.overflow = this.state.activePackage ? "hidden" : "auto";
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "auto";
    if (this.autoScrollInterval) clearInterval(this.autoScrollInterval);
  }

  startAutoScroll = () => {
    if (!this.scrollRef.current) return;

    this.autoScrollInterval = setInterval(() => {
      const container = this.scrollRef.current;
      if (container) {
        // Scroll slightly to the right every step
        container.scrollLeft += 1;

        // If reached end, reset back to start (loop effect)
        if (container.scrollLeft >= container.scrollWidth / 2) {
          container.scrollLeft = 0;
        }
      }
    }, 30); // adjust speed here
  };

  setActivePackage = (pkg: Package | null) => {
    this.setState({ activePackage: pkg });
  };

  scroll = (direction: "left" | "right") => {
    if (this.scrollRef.current) {
      const scrollAmount = 300; // how much to move per click
      this.scrollRef.current.scrollBy({
        left: direction === "right" ? scrollAmount : -scrollAmount,
        behavior: "smooth",
      });
    }
  };

  render() {
    const { packages, activePackage } = this.state;

    // Duplicate packages for smooth infinite scrolling
    const duplicatedPackages = [...packages, ...packages];

    return (
      <section className="packages-section">
        <h2 className="packages-headline">🌍 Travel Packages</h2>

        {/* Left/Right navigation arrows */}
        {/* <button className="carousel-arrow left" onClick={() => this.scroll("left")}>
          ◀
        </button>
        <button className="carousel-arrow right" onClick={() => this.scroll("right")}>
          ▶
        </button> */}

        {/* Scrollable container */}
        <div className="packages-scroll" ref={this.scrollRef}>
          {duplicatedPackages.map((pkg, index) => (
            <div key={`${pkg.id}-${index}`} onClick={() => this.setActivePackage(pkg)}>
              <PackageCard pkg={pkg} />
            </div>
          ))}
        </div>

        {/* Included / Excluded Section */}
        <div className="packages-info-block">
          <h3>Included</h3>
          <ul>
            <li>Accommodation 4★ with breakfast</li>
            <li>Driver with car</li>
            <li>Trips</li>
          </ul>

          <h3>Excluded</h3>
          <ul>
            <li>Ticket</li>
            <li>Insurance</li>
            <li>Anything not listed in "include"</li>
          </ul>
        </div>

        {/* Inquiry Modal */}
        {activePackage && (
          <InquiryModal
            show={!!activePackage}
            onClose={() => this.setActivePackage(null)}
            inquiryData={{
              type: "Package",
              from: undefined,
              to: undefined,
              date: undefined,
              name: "",
              email: "",
              phone: "",
              nameOfItem:activePackage.name,
              tripType: "", // ✅ Add this
            }}
          />
        )}
      </section>
    );
  }
}

export default PackagesSection;
